import * as trace from 'owa-trace';
import getTableToItemRelationKey from 'mini-mail-list-store/lib/utils/getTableToItemRelationKey';
import removeItemWithIdFromMailStore from 'mini-mail-reading-pane-store/lib/actions/removeItemWithIdFromMailStore';
import { getListViewStore } from 'mini-mail-list-store/lib/store/Store';
import { getReadingPaneStore } from 'mini-mail-reading-pane-store/lib/store/Store';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';

/**
 * This helper deletes the given item from the mail store if it's no longer referenced.
 * @param itemId identifier of the item to be deleted
 */
export const tryRemoveItemFromMailStore = (itemId: string) => {
    const item = getMailStore().items.get(itemId);
    if (!item) {
        trace.errorThatWillCauseAlert(
            "Item doesn't exist in mailStore: tryRemoveItemFromMailStore"
        );
        return;
    }
    if (isItemHeldByAnyListViewTable(itemId) || isItemHeldByItemReadingPane(itemId)) {
        return;
    }

    removeItemWithIdFromMailStore(itemId);
};

const isItemHeldByAnyListViewTable = (itemId: string): boolean => {
    const listViewStore = getListViewStore();
    for (const tableView of [...listViewStore.tableViews.values()]) {
        const tableItemRelationKey = getTableToItemRelationKey(itemId, tableView.id);
        if (listViewStore.tableViewItemRelations.has(tableItemRelationKey)) {
            return true;
        }
    }
    return false;
};

export const isItemHeldByItemReadingPane = (itemId: string): boolean =>
    !!(getReadingPaneStore().itemReadingPaneViewState?.itemId === itemId);
